
!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="15724470-1507-5bee-82be-00a8521c740a")}catch(e){}}();
(function(window, document) {
  'use strict';

  function markDecorativeFooterIcons() {
    document.querySelectorAll('.custom-footer .footer-contact svg, .custom-footer .material-icons').forEach(function(icon) {
      icon.setAttribute('aria-hidden', 'true');
      icon.setAttribute('focusable', 'false');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markDecorativeFooterIcons, { once: true });
  } else {
    markDecorativeFooterIcons();
  }
})(window, document);

//# debugId=15724470-1507-5bee-82be-00a8521c740a
